module.exports = __webpack_public_path__ + "static/img/nine.79852d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expert/nine.png
// module id = BCD1
// module chunks = 0